import { Table } from 'models/data';
import { ArticleVisibilityRow } from '../model';

export function transformArticleVisibilityTable(inputTable: Table): ArticleVisibilityRow[] {
  return Object.entries(inputTable.rows).map(([, row]) => ({
    id: row.name,
    name: row.name,
    subRows: [],
    actArtNumCD: {
      value: row.values.actArtNumCD,
      rate: row.values.actArtRateCD,
    },
    inaArtNumCD: {
      value: row.values.inaArtNumCD,
      rate: row.values.inaArtRateCD,
    },
    expArtNumCD: {
      value: row.values.expArtNumCD,
      rate: row.values.expArtRateCD,
    },
    nexArtNumCD: {
      value: row.values.nexArtNumCD,
      rate: row.values.nexArtRateCD,
    },
    asrOnlArtNumCD: {
      value: row.values.asrOnlArtNumCD,
      rate: row.values.asrOnlArtRateCD,
      flags: row.flags,
    },
    asrNonArtNumCD: {
      value: row.values.asrNonArtNumCD,
      rate: row.values.asrNonArtRateCD,
      flags: row.flags,
    },
    slgArtNumCD: {
      value: row.values.slgArtNumCD,
      rate: row.values.slgArtRateCD,
    },
    nslArtNumCD: {
      value: row.values.nslArtNumCD,
      rate: row.values.nslArtRateCD,
    },
  }));
}
